import { apiUrl } from '../../../settings'

export const listAllOnlineSubmissionUrl = () => {
  return apiUrl + '/v1/onlineSubmission'
}
export const addActivityUrl = () => {
  return apiUrl + '/v1/add-online-submission-activity'
}

export const singleOnlineSubmissionUrl = (id) => {
  return apiUrl + `/v1/onlineSubmission/${id}`
}
export const onlineSubmissionEmailUrl = () => {
  return apiUrl + `/v1/onlineSubmission/email`
}
export const onlineSubmissionExportUrl = () => {
  return apiUrl + `/v1/export/onlineSubmission`
}

export const onlineSubmissionActivityUrl = () => {
  return apiUrl + `/v1/online-submission/activity`
}


export const notesOnlineSubmissionUrl = () => {
  return apiUrl + '/v1/notes'
}
